/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiWebListysankcyjneDatyGet$Params {
  u?: string;
}

export function apiWebListysankcyjneDatyGet(http: HttpClient, rootUrl: string, params?: ApiWebListysankcyjneDatyGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<number>>> {
  const rb = new RequestBuilder(rootUrl, apiWebListysankcyjneDatyGet.PATH, 'get');
  if (params) {
    rb.query('u', params.u, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<number>>;
    })
  );
}

apiWebListysankcyjneDatyGet.PATH = '/api/web/listysankcyjne/daty';
